import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import BigModuleHead from '@src/pc/index/components/BigModuleHead';
import Chip from 'Chip';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const News = ({ newsData, newsHead }) => {
    return (
        <div className={styles.news}>
            <Chip id="260483" type="struct" title="最新资讯头" content={newsHead}>
                <BigModuleHead />
            </Chip>
            <div className={styles.newsBox}>
                {newsData.slice(0, 4).map((item, index) => {
                    const thumbnail = item?.thumbnails?.image?.[0]?.url || '';

                    return (
                        <a key={index} href={item.url} target="_blank" className={styles.newsFeed}>
                            <div className={styles.newsFeedPic}>
                                <img className={styles.newsFeedImage} src={formatImageWebpAuto(thumbnail, 171, 95)} />
                            </div>
                            <div className={styles.newsFeedText}>
                                <div className={styles.newsFeedTitle}>{item.title}</div>
                                <div className={styles.newsFeedTime}>{item.newsTime}</div>
                            </div>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

News.propTypes = {
    newsData: PropTypes.array,
    newsHead: PropTypes.object,
};

export default errorBoundary(News);
